interface LoadingOverlayProps {
  visible: boolean
  label?: string
}

export default function LoadingOverlay({ visible, label = 'LOADING INTEL...' }: LoadingOverlayProps) {
  if (!visible) return null

  return (
    <div className="absolute inset-0 z-30 flex items-center justify-center pointer-events-none">
      <div className="flex flex-col items-center gap-3 bg-gray-950/80 backdrop-blur-sm px-6 py-4 rounded-lg border border-green-900/50 shadow-[0_0_20px_rgba(34,197,94,0.1)]">
        <div className="relative w-10 h-10">
          <div className="absolute inset-0 rounded-full border-2 border-green-500/20" />
          <div className="absolute inset-0 rounded-full border-2 border-t-green-400 animate-spin" />
          <div className="absolute inset-1.5 rounded-full border border-t-red-400/60 animate-spin" style={{ animationDirection: 'reverse', animationDuration: '0.8s' }} />
        </div>
        <span className="text-[10px] font-mono text-green-400/80 tracking-[0.2em] uppercase drop-shadow-[0_0_4px_rgba(74,222,128,0.3)]">
          {label}
        </span>
      </div>
    </div>
  )
}
